module.exports = __webpack_public_path__ + "static/media/Profile unexpanded.f67907ce.jpg";